import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';

export const secureRoutes = ['./api'];
export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.auth.authority,
    redirectUrl: window.location.origin + '/auth',
    postLogoutRedirectUri: window.location.origin + '/auth',
    postLoginRoute: '/dashboard',
    forbiddenRoute: '/forbidden',
    clientId: environment.auth.clientId,
    scope: environment.auth.scope,
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    ignoreNonceAfterRefresh: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    strictIssuerValidationOnWellKnownRetrievalOff: true,
    secureRoutes: secureRoutes,
    logLevel: environment.auth.logLevel,
  },
};

export const adminOrgConfig = environment.auth.adminOrgConfig;
